export const LEDGER_TRANSACTIONS_ITEM_PER_PAGE = 25

// Canonical height for the controls on the Tenant Portal ledger toolbar
// row (the scope-tab pill group and the Download pill). Shared so the two
// controls always render at the same height and stay edge-aligned.
export const LEDGER_TOOLBAR_CONTROL_HEIGHT = '40px'
